import { boot } from 'quasar/wrappers'
import { bootstrapCustomerIo } from 'src/functions/customerio'

// Identifica o usuário já restaurado e também após login/atualização dos dados.
// No-op fora do cliente electroluxinstala.
export default boot(({ store }) => {
	bootstrapCustomerIo(store)

	// No primeiro boot, o Vuex ainda pode não ter um usuário. Esta inscrição
	// executa novamente a integração assim que read_user_data salva os dados.
	store.subscribe((mutation) => {
		if (mutation.type === 'common/SAVE_USER_DATA') {
			bootstrapCustomerIo(store)
		}
	})
})
